
(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('fileeditor', {
      restrict: 'E',
      bindings: {
        file: '<?',
        fileid: '<?'
      },
      template: `
        <fileform file="vm.file" parentsave="vm.childsave(file)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> file erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen file wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> file konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog',
        function ($log, File, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.file) || !vm.file.hasOwnProperty('_id'))
              && angular.isDefined(vm.fileid)) {
              getFile();
            }
          };

          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.fileid) && angular.isDefined(changes.fileid.currentValue) && changes.fileid.currentValue.length > 0){
              vm.fileid = changes.fileid.currentValue;
              getFile();
            }
          };

          function getFile() {
            File.$find(vm.fileid).$then(function (file) {
              vm.file = file;
            }, function (err) {
              $log.error('file not found, id: ', vm.fileid, err);
              Rlog.error('file', 'fileeditor', 'file not found', {_id: vm.fileid});
            });
          }

          function childsave(file) {
            // vm.file = angular.copy(file);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in file) {
              if (file.hasOwnProperty(key)) {
                vm.file[key] = file[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.file.$hasPendingActions()) {
              vm.file.$cancel();
              vm.file.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of file failed: ', err);
                Rlog.error('vcutils.file', 'fileeditor', 'Saving of file failed: ', {fileid: vm.file._id});
              });
            }
            else {
              vm.file.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of file failed: ', err);
                Rlog.error('vcutils.file', 'fileeditor', 'Saving of file failed: ', {fileid: vm.file._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }

        }] // controller
    }); // component

// klammerfriedhof
}());
